import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dashboard-just-sold-preloader',
    templateUrl: './dashboard-just-sold-preloader.component.html',
    styleUrls: ['./dashboard-just-sold-preloader.component.scss'],
    standalone: true
})
export class DashboardJustSoldPreloaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
